import { type DocumentReference } from '@principle-theorem/shared';
import { type AttachmentJSON } from '@sendgrid/helpers/classes/attachment';
import { type IPractice } from '../practice/practice';
import { EmailMessage } from './email-message';

export interface ISendEmailRequest {
  to: string;
  subject: string;
  text?: string;
  html: string;
  metadata: SendEmailRequestMetadata;
  replyToken?: string;
  attachments?: AttachmentJSON[];
  cc?: string;
  bcc?: string;
  headers?: { [key: string]: string };
}

export type SendEmailRequestMetadata = {
  senderRef: DocumentReference<IPractice>;
  emailRef?: DocumentReference<EmailMessage>;
};
